export const setBrowserPopupBlocked = (isBlocked) => ({
  type: "SET_POPUP_BLOCKED",
  payload: isBlocked,
});
